module.exports = __webpack_public_path__ + "img/pdf-file.87453709.png";